import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Link, Typography } from '@mui/material';

import { COLORS } from '../IndividualPlan/tokens';

type CancelMatchDialogProps = {
  open: boolean;
  onKeepMatching: () => void;
  onConfirmCancel: () => void;
};

export function CancelMatchDialog({ open, onKeepMatching, onConfirmCancel }: CancelMatchDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onKeepMatching}
      fullWidth
      maxWidth="sm"
      PaperProps={{ sx: { borderRadius: 2, p: 1 } }}
    >
      <DialogTitle sx={{ fontWeight: 700, color: COLORS.ink, pb: 1 }}>
        Are you sure you want to cancel?
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: 14, color: COLORS.muted, lineHeight: 1.5 }}>
          Your column matching progress won&rsquo;t be saved. You can start matching again anytime from
          the Data &amp; Integrations page.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Link
          component="button"
          underline="hover"
          onClick={onKeepMatching}
          sx={{ color: COLORS.navy, fontWeight: 600, fontSize: 14, mr: 2 }}
        >
          Keep matching
        </Link>
        <Button
          variant="contained"
          onClick={onConfirmCancel}
          sx={{
            bgcolor: COLORS.navy,
            textTransform: 'none',
            fontWeight: 600,
            px: 3,
            py: 1,
            borderRadius: 1.5,
            '&:hover': { bgcolor: '#18185A' },
          }}
        >
          Yes, cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
